import { BaseProviderInstance } from './base-provider-instance';

export class ProviderInstanceApplication extends BaseProviderInstance {
  providerTypeId: string;
}
